<template>
    <div id="app">
    <keep-alive>
     <router-view  v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive> 
    <router-view v-if="!$route.meta.keepAlive"> ></router-view>

  </div>
</template>

<script>

export default {
  name: 'App',
  created(){
    console.log("app2");
  },
  components: {
  }
}
</script>

<style lang="scss"> 

 /* 自定义图标库 */
	@import "./common/free.css";
    
  html,body,#app{
        height: 100%;
        background:#fff ;
  }


</style>
